import { getProfile } from '../api'
import { createReactQueryHook } from '../types'

export const useQueryGetProfile = createReactQueryHook('getProfile', getProfile)
